import React, { lazy } from 'react'
import { Redirect, Route } from 'react-router-dom'

import RouterSwitch from 'components/atoms/RouterSwitch'
import { ONE_SECOND } from 'config/date'

const Login = lazy(() => import('routes/Auth/Login'))
const Signup = lazy(() => import('routes/Auth/Signup'))
const SendSignup = lazy(() => import('routes/Auth/Signup/SendSignup'))
const ResendSignup = lazy(() => import('routes/Auth/Signup/ResendSignup'))
const ResetPassword = lazy(() => import('routes/Auth/ResetPassword'))
const SendResetPassword = lazy(
  () => import('routes/Auth/ResetPassword/SendResetPassword')
)
const ResendResetPassword = lazy(
  () => import('routes/Auth/ResetPassword/ResendResetPassword')
)

function Auth() {
  return (
    <RouterSwitch>
      <Route path="/signup/expired-link/:email" component={ResendSignup} />
      <Route
        path="/signup/:timestamp/:token/:email"
        render={(props) =>
          props.match.params.timestamp * ONE_SECOND > new Date().getTime() ? (
            <Signup {...props} />
          ) : (
            <Redirect to={`/signup/expired-link/${props.match.params.email}`} />
          )
        }
      />
      <Route path="/signup/notification-link/:email" component={Signup} />
      <Route path="/signup" component={SendSignup} />
      <Route
        path="/reset-password/expired-link/:email"
        component={ResendResetPassword}
      />
      <Route
        path="/reset-password/used-link/:email"
        render={(props) => <ResendResetPassword {...props} usedLink />}
      />
      <Route
        path="/reset-password/:timestamp/:token/:email"
        render={(props) =>
          props.match.params.timestamp * ONE_SECOND > new Date().getTime() ? (
            <ResetPassword {...props} />
          ) : (
            <Redirect
              to={`/reset-password/expired-link/${props.match.params.email}`}
            />
          )
        }
      />
      <Route path="/reset-password" component={SendResetPassword} />
      <Route path="/" component={Login} />
    </RouterSwitch>
  )
}

export default React.memo(Auth)
